import React, { Component } from 'react';
import classnames from 'classnames';
import SnackBar from 'components/SnackBar';
import { TEACHER_MENU } from 'config/constants';
import { withRouter } from 'react-router';

import TeacherNavbar from '../../navigation/TeacherNavbar';

import './style.css';

class TeacherLayout extends Component {
  render() {
    const { location } = this.props;

    const selectedMenu = TEACHER_MENU.find(menu => location.pathname.includes(menu.path));
    const hasSubmenu = Boolean(selectedMenu && selectedMenu.submenu);

    return (
      <div className={classnames('TeacherLayout row', { 'has-submenu': hasSubmenu })}>
        <aside id="sidebar" className="col d-flex px-0 hidden-sm-down">
          <TeacherNavbar />
        </aside>

        <div className="content-wrapper col mb-0">{this.props.children}</div>
        <SnackBar />
      </div>
    );
  }
}

export default withRouter(TeacherLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/TeacherLayout/index.js